const mappedNerves = [
  {
    "id": 0,
    "nerve_id": "ILX:0793723",
    "label": "Auriculotemporal nerve",
    "FMA subclasses (in human nerves)": ['FMA:53002', 'FMA:53001'],
    "subclass labels": ['Left auriculotemporal nerve', 'Right auriculotemporal nerve']
  },
  {
    "id": 1,
    "nerve_id": "ILX:0792409",
    "label": "gray communicating ramus of tenth thoracic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6895', 'FMA:6894'],
    "subclass labels": ['Left T10 grey ramus communicans', 'Right T10 grey ramus communicans']
  },
  {
    "id": 2,
    "nerve_id": "UBERON:0011326",
    "label": "superior laryngeal nerve",
    "FMA subclasses (in human nerves)": ['FMA:53530', 'FMA:53536'],
    "subclass labels": ['Right superior laryngeal nerve', 'Left superior laryngeal nerve']
  },
  {
    "id": 3,
    "nerve_id": "ILX:0793220",
    "label": "white communicating ramus of first lumbar spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 4,
    "nerve_id": "ILX:0787082",
    "label": "gray communicating ramus of the first thoracic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6082', 'FMA:6084'],
    "subclass labels": ['Right T1 grey ramus communicans', 'Left T1 grey ramus communicans']
  },
  {
    "id": 5,
    "nerve_id": "ILX:0793809",
    "label": "Clitoral cavernous nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 6,
    "nerve_id": "UBERON:0011096",
    "label": "lacrimal nerve",
    "FMA subclasses (in human nerves)": ['FMA:52630', 'FMA:52629'],
    "subclass labels": ['Left lacrimal nerve', 'Right lacrimal nerve']
  },
  {
    "id": 7,
    "nerve_id": "ILX:0793215",
    "label": "white communicating ramus of ninth thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 8,
    "nerve_id": "ILX:0795005",
    "label": "Posterior cutaneous nerve of arm",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 9,
    "nerve_id": "UBERON:0001649",
    "label": "glossopharyngeal nerve",
    "FMA subclasses (in human nerves)": ['FMA:50894', 'FMA:50892'],
    "subclass labels": []
  },
  {
    "id": 10,
    "nerve_id": "UBERON:0022302",
    "label": "short ciliary nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 11,
    "nerve_id": "ILX:0785932",
    "label": "gray communicating ramus of third lumbar nerve",
    "FMA subclasses (in human nerves)": ['FMA:65920', 'FMA:65919'],
    "subclass labels": ['Left L3 grey ramus communicans', 'Right L3 grey ramus communicans']
  },
  {
    "id": 12,
    "nerve_id": "ILX:0738293",
    "label": "Ganglioglomerular nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 13,
    "nerve_id": "ILX:0739298",
    "label": "gray communicating ramus of twelfth thoracic nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 14,
    "nerve_id": "UBERON:0001492",
    "label": "radial nerve",
    "FMA subclasses (in human nerves)": ['FMA:37070', 'FMA:37071'],
    "subclass labels": ['Right radial nerve', 'Left radial nerve']
  },
  {
    "id": 15,
    "nerve_id": "ILX:0793214",
    "label": "white communicating ramus of eighth thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 16,
    "nerve_id": "UBERON:0018681",
    "label": "lesser splanchnic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6957', 'FMA:6958'],
    "subclass labels": ['Right lesser splanchnic nerve', 'Left lesser splanchnic nerve']
  },
  {
    "id": 17,
    "nerve_id": "ILX:0794476",
    "label": "abdominal branch of vagus nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 18,
    "nerve_id": "ILX:0791105",
    "label": "gray communicating ramus of the second thoracic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6122', 'FMA:6757'],
    "subclass labels": ['Right T2 grey ramus communicans', 'Left T2 grey ramus communicans']
  },
  {
    "id": 19,
    "nerve_id": "ILX:0794853",
    "label": "esophageal vagus trunk",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 20,
    "nerve_id": "ILX:0793210",
    "label": "white communicating ramus of fourth thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 21,
    "nerve_id": "UBERON:0001759",
    "label": "vagus nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 22,
    "nerve_id": "UBERON:0009675",
    "label": "chorda tympani branch of facial nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 23,
    "nerve_id": "ILX:0794949",
    "label": "recurrent branch of the median nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 24,
    "nerve_id": "ILX:0789339",
    "label": "Pharyngeal branch of glossopharyngeal nerve",
    "FMA subclasses (in human nerves)": ['FMA:53495', 'FMA:53494'],
    "subclass labels": ['Pharyngeal branch of left glossopharyngeal nerve', 'Pharyngeal branch of right glossopharyngeal nerve']
  },
  {
    "id": 25,
    "nerve_id": "ILX:0793712",
    "label": "Zygomatic nerve",
    "FMA subclasses (in human nerves)": ['FMA:52968', 'FMA:52969'],
    "subclass labels": ['Right zygomatic nerve', 'Left zygomatic nerve']
  },
  {
    "id": 26,
    "nerve_id": "ILX:0788536",
    "label": "gray communicating ramus of fourth lumbar nerve",
    "FMA subclasses (in human nerves)": ['FMA:65917', 'FMA:65918'],
    "subclass labels": ['Right L4 grey ramus communicans', 'Left L4 grey ramus communicans']
  },
  {
    "id": 27,
    "nerve_id": "UBERON:0018680",
    "label": "greater splanchnic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6956', 'FMA:6955'],
    "subclass labels": ['Right greater splanchnic nerve', 'Left greater splanchnic nerve']
  },
  {
    "id": 28,
    "nerve_id": "UBERON:0001322",
    "label": "sciatic nerve",
    "FMA subclasses (in human nerves)": ['FMA:22111', 'FMA:22112'],
    "subclass labels": ['Right sciatic nerve', 'Left sciatic nerve']
  },
  {
    "id": 29,
    "nerve_id": "ILX:0793209",
    "label": "white communicating ramus of third thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 30,
    "nerve_id": "UBERON:0011391",
    "label": "perineal nerve",
    "FMA subclasses (in human nerves)": ['FMA:21874', 'FMA:21873'],
    "subclass labels": ['Left perineal nerve', 'Right perineal nerve']
  },
  {
    "id": 31,
    "nerve_id": "ILX:0788945",
    "label": "gray communicating ramus of the fourth thoracic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6759', 'FMA:6758'],
    "subclass labels": ['Right T4 grey ramus communicans', 'Left T4 grey ramus communicans']
  },
  {
    "id": 32,
    "nerve_id": "ILX:0790497",
    "label": "Gray communicating ramus of cervicothoracic ganglion to first thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 33,
    "nerve_id": "UBERON:0001323",
    "label": "tibial nerve",
    "FMA subclasses (in human nerves)": ['FMA:22109', 'FMA:22110'],
    "subclass labels": ['Right tibial nerve', 'Left tibial nerve']
  },
  {
    "id": 34,
    "nerve_id": "ILX:0794969",
    "label": "deep branch of ulnar nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 35,
    "nerve_id": "ILX:0793227",
    "label": "gray communicating ramus of thirteenth thoracic nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 36,
    "nerve_id": "ILX:0793228",
    "label": "gray communicating ramus of first sacral nerve",
    "FMA subclasses (in human nerves)": ['FMA:65992', 'FMA:65991'],
    "subclass labels": ['Left S1 grey ramus communicans', 'Right S1 grey ramus communicans']
  },
  {
    "id": 37,
    "nerve_id": "UBERON:0035111",
    "label": "medial plantar nerve",
    "FMA subclasses (in human nerves)": ['FMA:45435', 'FMA:45434'],
    "subclass labels": ['Left medial plantar nerve', 'Right medial plantar nerve']
  },
  {
    "id": 38,
    "nerve_id": "UBERON:0001780",
    "label": "spinal nerve",
    "FMA subclasses (in human nerves)": ['FMA:6117', 'FMA:6435', 'FMA:6295', 'FMA:6422', 'FMA:6417', 'FMA:6421', 'FMA:6038', 'FMA:6292', 'FMA:6439', 'FMA:6313', 'FMA:6410', 'FMA:6412', 'FMA:6088', 'FMA:6298', 'FMA:6433', 'FMA:6411', 'FMA:6438', 'FMA:6314', 'FMA:6291', 'FMA:6420', 'FMA:6116', 'FMA:6413', 'FMA:6310', 'FMA:6432', 'FMA:6305', 'FMA:6182', 'FMA:6297', 'FMA:6436', 'FMA:6418', 'FMA:6039', 'FMA:6089', 'FMA:6301', 'FMA:6294', 'FMA:6303', 'FMA:6183', 'FMA:6434', 'FMA:6429', 'FMA:6308', 'FMA:6300', 'FMA:6430', 'FMA:6428', 'FMA:6419', 'FMA:6437', 'FMA:6307', 'FMA:6311', 'FMA:6431'],
    "subclass labels": ['Left T3 spinal nerve', 'Left S4 spinal nerve', 'Left T5 spinal nerve', 'Left L5 spinal nerve', 'Right L3 spinal nerve', 'Right L5 spinal nerve', 'Right T1 spinal nerve', 'Left T4 spinal nerve', 'Left coccygeal spinal nerve', 'Right T11 spinal nerve', 'Right L1 spinal nerve', 'Right L2 spinal nerve', 'Right T2 spinal nerve', 'Left T6 spinal nerve', 'Left S3 spinal nerve', 'Left L1 spinal nerve', 'Right coccygeal spinal nerve', 'Left T11 spinal nerve', 'Right T4 spinal nerve', 'Left L4 spinal nerve', 'Right T3 spinal nerve', 'Left L2 spinal nerve', 'Right T10 spinal nerve', 'Right S3 spinal nerve', 'Left T8 spinal nerve', 'Right T12 spinal nerve', 'Right T6 spinal nerve', 'Right S5 spinal nerve', 'Left L3 spinal nerve', 'Left T1 spinal nerve', 'Left T2 spinal nerve', 'Left T7 spinal nerve', 'Right T5 spinal nerve', 'Right T8 spinal nerve', 'Left T12 spinal nerve', 'Right S4 spinal nerve', 'Left S1 spinal nerve', 'Left T9 spinal nerve', 'Right T7 spinal nerve', 'Right S2 spinal nerve', 'Right S1 spinal nerve', 'Right L4 spinal nerve', 'Left S5 spinal nerve', 'Right T9 spinal nerve', 'Left T10 spinal nerve', 'Left S2 spinal nerve']
  },
  {
    "id": 39,
    "nerve_id": "UBERON:0018683",
    "label": "lumbar splanchnic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6924', 'FMA:6928', 'FMA:6929', 'FMA:6931', 'FMA:6925', 'FMA:6930', 'FMA:6927', 'FMA:6926'],
    "subclass labels": ['Right first lumbar splanchnic nerve', 'Right third lumbar splanchnic nerve', 'Left third lumbar splanchnic nerve', 'Left fourth lumbar splanchnic nerve', 'Left first lumbar splanchnic nerve', 'Right fourth lumbar splanchnic nerve', 'Left second lumbar splanchnic nerve', 'Right second lumbar splanchnic nerve']
  },
  {
    "id": 40,
    "nerve_id": "UBERON:0001643",
    "label": "oculomotor nerve",
    "FMA subclasses (in human nerves)": ['FMA:50880', 'FMA:50879'],
    "subclass labels": ['Left oculomotor nerve', 'Right oculomotor nerve']
  },
  {
    "id": 41,
    "nerve_id": "ILX:0793212",
    "label": "white communicating ramus of sixth thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 42,
    "nerve_id": "UBERON:0003724",
    "label": "musculocutaneous nerve",
    "FMA subclasses (in human nerves)": ['FMA:37066', 'FMA:37065'],
    "subclass labels": ['Left musculocutaneous nerve', 'Right musculocutaneous nerve']
  },
  {
    "id": 43,
    "nerve_id": "ILX:0738372",
    "label": "white communicating ramus of first thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 44,
    "nerve_id": "ILX:0793563",
    "label": "splenic nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 45,
    "nerve_id": "UBERON:0035526",
    "label": "superficial fibular nerve",
    "FMA subclasses (in human nerves)": ['FMA:45363', 'FMA:45364'],
    "subclass labels": ['Right superficial fibular nerve', 'Left superficial fibular nerve']
  },
  {
    "id": 46,
    "nerve_id": "ILX:0791560",
    "label": "gray communicating ramus of eighth thoracic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6891', 'FMA:6890'],
    "subclass labels": ['Left T8 grey ramus communicans', 'Right T8 grey ramus communicans']
  },
  {
    "id": 47,
    "nerve_id": "ILX:0793827",
    "label": "posterior abdominal vagal trunk",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 48,
    "nerve_id": "ILX:0794141",
    "label": "right cervical vagus nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 49,
    "nerve_id": "ILX:0793714",
    "label": "Mesenteric nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 50,
    "nerve_id": "UBERON:0001964",
    "label": "least splanchnic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6960', 'FMA:6959'],
    "subclass labels": ['Left least splanchnic nerve', 'Right least splanchnic nerve']
  },
  {
    "id": 51,
    "nerve_id": "UBERON:0001267",
    "label": "femoral nerve",
    "FMA subclasses (in human nerves)": ['FMA:16499', 'FMA:16500'],
    "subclass labels": ['Right femoral nerve', 'Left femoral nerve']
  },
  {
    "id": 52,
    "nerve_id": "UBERON:0034984",
    "label": "nerve to quadratus femoris",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 53,
    "nerve_id": "UBERON:0003721",
    "label": "lingual nerve",
    "FMA subclasses (in human nerves)": ['FMA:53219', 'FMA:53220'],
    "subclass labels": ['Right lingual nerve', 'Left lingual nerve']
  },
  {
    "id": 54,
    "nerve_id": "UBERON:0036216",
    "label": "tympanic nerve",
    "FMA subclasses (in human nerves)": ['FMA:53481', 'FMA:53482'],
    "subclass labels": ['Right tympanic nerve', 'Left tympanic nerve']
  },
  {
    "id": 55,
    "nerve_id": "ILX:0793216",
    "label": "white communicating ramus of tenth thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 56,
    "nerve_id": "ILX:0793362",
    "label": "White communicating ramus of fourth lumbar anterior ramus",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 57,
    "nerve_id": "ILX:0793561",
    "label": "Internal branch of superior laryngeal nerve",
    "FMA subclasses (in human nerves)": ['FMA:53539', 'FMA:53540'],
    "subclass labels": ['Right internal laryngeal nerve', 'Left internal laryngeal nerve']
  },
  {
    "id": 58,
    "nerve_id": "ILX:0738312",
    "label": "Aortic arch depressor nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 59,
    "nerve_id": "ILX:0793218",
    "label": "white communicating ramus of twelfth thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 60,
    "nerve_id": "ILX:0738308",
    "label": "External branch of inferior laryngeal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 61,
    "nerve_id": "ILX:0739299",
    "label": "gray communicating ramus of sixth lumbar nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 62,
    "nerve_id": "ILX:0793559",
    "label": "bladder nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 63,
    "nerve_id": "ILX:0793822",
    "label": "Superior ovarian nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 64,
    "nerve_id": "ILX:0793807",
    "label": "Penile cavernous nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 65,
    "nerve_id": "UBERON:0011390",
    "label": "pudendal nerve",
    "FMA subclasses (in human nerves)": ['FMA:21863', 'FMA:21864'],
    "subclass labels": ['Right pudendal nerve', 'Left pudendal nerve']
  },
  {
    "id": 66,
    "nerve_id": "UBERON:0008810",
    "label": "nasopalatine nerve",
    "FMA subclasses (in human nerves)": ['FMA:52799', 'FMA:52798'],
    "subclass labels": ['Left nasopalatine nerve', 'Right nasopalatine nerve']
  },
  {
    "id": 67,
    "nerve_id": "ILX:0793219",
    "label": "white communicating ramus of thirteenth thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 68,
    "nerve_id": "ILX:0793632",
    "label": "lumbar colonic nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 69,
    "nerve_id": "ILX:0784439",
    "label": "gray communicating ramus of the fifth thoracic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6760', 'FMA:6761'],
    "subclass labels": ['Left T5 grey ramus communicans', 'Right T5 grey ramus communicans']
  },
  {
    "id": 70,
    "nerve_id": "ILX:0794977",
    "label": "deep branch of radial nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 71,
    "nerve_id": "UBERON:0001884",
    "label": "phrenic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6193', 'FMA:6192'],
    "subclass labels": ['Left phrenic nerve', 'Right phrenic nerve']
  },
  {
    "id": 72,
    "nerve_id": "UBERON:0035110",
    "label": "lateral plantar nerve",
    "FMA subclasses (in human nerves)": ['FMA:45450', 'FMA:45451'],
    "subclass labels": ['Right lateral plantar nerve', 'Left lateral plantar nerve']
  },
  {
    "id": 73,
    "nerve_id": "ILX:0793711",
    "label": "Communicating branch of zygomatic nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 74,
    "nerve_id": "ILX:0793560",
    "label": "External branch of superior laryngeal nerve",
    "FMA subclasses (in human nerves)": ['FMA:53537', 'FMA:53538'],
    "subclass labels": ['Right external laryngeal nerve', 'Left external laryngeal nerve']
  },
  {
    "id": 75,
    "nerve_id": "ILX:0738309",
    "label": "Internal branch of inferior laryngeal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 76,
    "nerve_id": "UBERON:0001021",
    "label": "nerve",
    "FMA subclasses (in human nerves)": ['FMA:6775', 'FMA:6894', 'FMA:6784', 'FMA:6728', 'FMA:65325', 'FMA:21873', 'FMA:45429', 'FMA:6844', 'FMA:53609', 'FMA:7116', 'FMA:44770', 'FMA:8916', 'FMA:52995', 'FMA:6071', 'FMA:45309', 'FMA:6122', 'FMA:6892', 'FMA:6767', 'FMA:16405', 'FMA:53560', 'FMA:6092', 'FMA:65343', 'FMA:37066', 'FMA:8894', 'FMA:8868', 'FMA:65341', 'FMA:53559', 'FMA:8897', 'FMA:82956', 'FMA:20633', 'FMA:6763', 'FMA:65339', 'FMA:8829', 'FMA:16493', 'FMA:8817', 'FMA:8821', 'FMA:11757', 'FMA:45456', 'FMA:45422', 'FMA:11261', 'FMA:65388', 'FMA:6192', 'FMA:65347', 'FMA:37068', 'FMA:65995', 'FMA:6764', 'FMA:39081', 'FMA:45338', 'FMA:53402', 'FMA:11210', 'FMA:52644', 'FMA:37067', 'FMA:65313', 'FMA:11153', 'FMA:6155', 'FMA:8797', 'FMA:53302', 'FMA:8883', 'FMA:53067', 'FMA:52939', 'FMA:53301', 'FMA:292889', 'FMA:45423', 'FMA:8791', 'FMA:45380', 'FMA:11759', 'FMA:7305', 'FMA:8830', 'FMA:78650', 'FMA:65389', 'FMA:45387', 'FMA:8827', 'FMA:8912', 'FMA:52941', 'FMA:6743', 'FMA:7126', 'FMA:53485', 'FMA:16492', 'FMA:53399', 'FMA:65337', 'FMA:11209', 'FMA:6772', 'FMA:52726', 'FMA:6121', 'FMA:52627', 'FMA:52974', 'FMA:53571', 'FMA:6729', 'FMA:8729', 'FMA:53606', 'FMA:80025', 'FMA:53481', 'FMA:53575', 'FMA:45451', 'FMA:11218', 'FMA:22109', 'FMA:6852', 'FMA:8909', 'FMA:11751', 'FMA:65991', 'FMA:8836', 'FMA:65350', 'FMA:53423', 'FMA:65569', 'FMA:65314', 'FMA:82957', 'FMA:65438', 'FMA:39146', 'FMA:8911', 'FMA:22111', 'FMA:65916', 'FMA:65739', 'FMA:65917', 'FMA:6779', 'FMA:8889', 'FMA:65924', 'FMA:65316', 'FMA:53002', 'FMA:16887', 'FMA:53366', 'FMA:6890', 'FMA:8790', 'FMA:6730', 'FMA:45358', 'FMA:52716', 'FMA:53494', 'FMA:7115', 'FMA:53561', 'FMA:78655', 'FMA:45366', 'FMA:11219', 'FMA:11555', 'FMA:7092', 'FMA:53220', 'FMA:45428', 'FMA:6193', 'FMA:20604', 'FMA:45433', 'FMA:21874', 'FMA:21875', 'FMA:53244', 'FMA:45432', 'FMA:6770', 'FMA:52640', 'FMA:11249', 'FMA:20630', 'FMA:53308', 'FMA:11216', 'FMA:65399', 'FMA:78649', 'FMA:11084', 'FMA:6897', 'FMA:53633', 'FMA:6085', 'FMA:6851', 'FMA:45457', 'FMA:6757', 'FMA:8732', 'FMA:8824', 'FMA:20632', 'FMA:6137', 'FMA:52730', 'FMA:7301', 'FMA:52699', 'FMA:53607', 'FMA:7300', 'FMA:53576', 'FMA:44904', 'FMA:65342', 'FMA:7127', 'FMA:6737', 'FMA:52669', 'FMA:21876', 'FMA:45425', 'FMA:65999', 'FMA:8728', 'FMA:21871', 'FMA:55172', 'FMA:6149', 'FMA:45453', 'FMA:44932', 'FMA:292832', 'FMA:6744', 'FMA:6781', 'FMA:44769', 'FMA:45326', 'FMA:6760', 'FMA:53634', 'FMA:53605', 'FMA:53530', 'FMA:6821', 'FMA:52968', 'FMA:53001', 'FMA:11552', 'FMA:45264', 'FMA:8835', 'FMA:6888', 'FMA:55160', 'FMA:44899', 'FMA:52979', 'FMA:45333', 'FMA:45310', 'FMA:6084', 'FMA:11781', 'FMA:82962', 'FMA:53280', 'FMA:52715', 'FMA:53311', 'FMA:16491', 'FMA:21880', 'FMA:44952', 'FMA:11687', 'FMA:11212', 'FMA:65335', 'FMA:52940', 'FMA:6774', 'FMA:8823', 'FMA:45388', 'FMA:6666', 'FMA:6072', 'FMA:16886', 'FMA:53312', 'FMA:65915', 'FMA:45357', 'FMA:11262', 'FMA:65921', 'FMA:0328826', 'FMA:81290', 'FMA:53279', 'FMA:11551', 'FMA:7293', 'FMA:6677', 'FMA:11756', 'FMA:53598', 'FMA:52732', 'FMA:44902', 'FMA:53545', 'FMA:6740', 'FMA:53502', 'FMA:53562', 'FMA:52700', 'FMA:7122', 'FMA:6118', 'FMA:65918', 'FMA:8814', 'FMA:16403', 'FMA:65346', 'FMA:6667', 'FMA:52630', 'FMA:52629', 'FMA:8871', 'FMA:16500', 'FMA:52725', 'FMA:6108', 'FMA:45363', 'FMA:65340', 'FMA:8872', 'FMA:11760', 'FMA:53604', 'FMA:11214', 'FMA:52777', 'FMA:21864', 'FMA:53503', 'FMA:6738', 'FMA:66000', 'FMA:6776', 'FMA:6777', 'FMA:6765', 'FMA:6111', 'FMA:8890', 'FMA:20607', 'FMA:52643', 'FMA:8908', 'FMA:65437', 'FMA:6762', 'FMA:11154', 'FMA:65344', 'FMA:52937', 'FMA:8919', 'FMA:45354', 'FMA:6766', 'FMA:53424', 'FMA:6145', 'FMA:65568', 'FMA:20634', 'FMA:6732', 'FMA:8893', 'FMA:11758', 'FMA:6889', 'FMA:11554', 'FMA:65922', 'FMA:7118', 'FMA:16884', 'FMA:45308', 'FMA:7290', 'FMA:6758', 'FMA:65743', 'FMA:11063', 'FMA:16885', 'FMA:8882', 'FMA:65286', 'FMA:291238', 'FMA:53482', 'FMA:52976', 'FMA:11308', 'FMA:53432', 'FMA:53540', 'FMA:45379', 'FMA:44871', 'FMA:6714', 'FMA:82955', 'FMA:65993', 'FMA:45452', 'FMA:52626', 'FMA:6083', 'FMA:53582', 'FMA:65919', 'FMA:52936', 'FMA:53506', 'FMA:8918', 'FMA:44901', 'FMA:6073', 'FMA:65315', 'FMA:53219', 'FMA:11194', 'FMA:6792', 'FMA:7119', 'FMA:52785', 'FMA:7296', 'FMA:53068', 'FMA:6845', 'FMA:52677', 'FMA:53504', 'FMA:53548', 'FMA:52698', 'FMA:53570', 'FMA:6771', 'FMA:7078', 'FMA:65997', 'FMA:65338', 'FMA:52969', 'FMA:16401', 'FMA:65416', 'FMA:6835', 'FMA:39082', 'FMA:8726', 'FMA:45254', 'FMA:8879', 'FMA:11250', 'FMA:53049', 'FMA:45382', 'FMA:8795', 'FMA:53495', 'FMA:45434', 'FMA:82963', 'FMA:0328827', 'FMA:52656', 'FMA:82961', 'FMA:11753', 'FMA:39147', 'FMA:45339', 'FMA:20605', 'FMA:20631', 'FMA:8898', 'FMA:6070', 'FMA:44892', 'FMA:16404', 'FMA:52942', 'FMA:6082', 'FMA:8861', 'FMA:82953', 'FMA:8808', 'FMA:8805', 'FMA:52994', 'FMA:65348', 'FMA:55173', 'FMA:7129', 'FMA:52674', 'FMA:44894', 'FMA:55159', 'FMA:65327', 'FMA:37320', 'FMA:6761', 'FMA:65349', 'FMA:11253', 'FMA:53507', 'FMA:11213', 'FMA:7307', 'FMA:6769', 'FMA:6759', 'FMA:55155', 'FMA:53675', 'FMA:53599', 'FMA:65282', 'FMA:53251', 'FMA:6731', 'FMA:11111', 'FMA:16497', 'FMA:8878', 'FMA:11211', 'FMA:65740', 'FMA:45367', 'FMA:53588', 'FMA:45365', 'UBERON:0011766', 'FMA:16502', 'FMA:6891', 'FMA:6091', 'FMA:11018', 'FMA:6090', 'FMA:292887', 'FMA:65401', 'FMA:65326', 'FMA:11215', 'FMA:44735', 'FMA:8735', 'FMA:53538', 'FMA:6849', 'FMA:53608', 'FMA:11217', 'FMA:8860', 'FMA:6134', 'FMA:6893', 'FMA:53534', 'FMA:45361', 'FMA:37321', 'FMA:82734', 'FMA:22112', 'FMA:7294', 'FMA:52987', 'FMA:65247', 'FMA:53535', 'FMA:6895', 'FMA:52787', 'FMA:53635', 'FMA:65920', 'FMA:55156', 'FMA:16498', 'FMA:53569', 'FMA:6739', 'FMA:8807', 'FMA:22110', 'FMA:81294', 'FMA:45450', 'FMA:8922', 'FMA:8725', 'FMA:20608', 'FMA:7308', 'FMA:65281', 'FMA:39084', 'FMA:78656', 'FMA:6133', 'FMA:53581', 'FMA:16494', 'FMA:53252', 'FMA:11789', 'FMA:45364', 'FMA:65345', 'FMA:44870', 'FMA:39083', 'FMA:45355', 'FMA:11193', 'FMA:16400', 'FMA:81287', 'FMA:52776', 'FMA:65747', 'FMA:8900', 'UBERON:0011767', 'FMA:45424', 'FMA:292830', 'FMA:44734', 'FMA:45381', 'FMA:82960', 'FMA:0328831', 'FMA:6689', 'FMA:7077', 'FMA:291236', 'FMA:8886', 'FMA:276381', 'FMA:6124', 'FMA:65336', 'FMA:65328', 'FMA:52670', 'FMA:53537', 'FMA:53636', 'FMA:6896', 'FMA:21879', 'FMA:8798', 'FMA:81288', 'FMA:53542', 'FMA:45368', 'FMA:53547', 'FMA:55157', 'FMA:65415', 'FMA:53309', 'FMA:65744', 'FMA:53367', 'FMA:53590', 'FMA:65923', 'FMA:53048', 'FMA:16499', 'FMA:53610', 'FMA:44951', 'FMA:44953', 'FMA:8832', 'FMA:45426', 'FMA:6114', 'FMA:52799', 'FMA:11039', 'FMA:53546', 'FMA:53589', 'FMA:8901', 'FMA:11681', 'FMA:52639', 'FMA:8905', 'FMA:52733', 'FMA:65992', 'FMA:52807', 'FMA:45435', 'FMA:53484', 'FMA:52975', 'FMA:7289', 'FMA:44905', 'FMA:37071', 'FMA:7130', 'FMA:65996', 'FMA:6132', 'FMA:8826', 'FMA:6741', 'FMA:11252', 'FMA:8917', 'FMA:82954', 'FMA:6832', 'FMA:37073', 'FMA:37074', 'FMA:44893', 'FMA:82959', 'FMA:20635', 'FMA:6093', 'FMA:65248', 'FMA:45362', 'FMA:52622', 'FMA:53508', 'FMA:11755', 'FMA:82958', 'FMA:52997', 'FMA:16501', 'FMA:65402', 'FMA:45427', 'FMA:52803', 'FMA:16402', 'FMA:8734', 'FMA:52784', 'FMA:45454', 'FMA:6736', 'FMA:7304', 'FMA:6742', 'FMA:52998', 'FMA:52804', 'FMA:11788', 'FMA:6713', 'FMA:52623', 'FMA:53536', 'FMA:11780', 'FMA:45334', 'FMA:52701', 'FMA:65998', 'FMA:11092', 'FMA:6684', 'FMA:52779', 'FMA:52778', 'FMA:78652', 'FMA:0328830', 'FMA:6733', 'FMA:44950', 'FMA:78653', 'FMA:45455', 'FMA:8864', 'FMA:8833', 'FMA:8876', 'FMA:8867', 'FMA:11752', 'FMA:53541', 'FMA:53611', 'FMA:8904', 'FMA:6745', 'FMA:21863', 'FMA:7297', 'FMA:52676', 'FMA:52798', 'FMA:8818', 'FMA:82735', 'FMA:52657', 'FMA:52786', 'FMA:6773', 'FMA:45253', 'FMA:6127', 'FMA:45263', 'FMA:8875', 'FMA:81295', 'FMA:11754', 'FMA:8812', 'FMA:45311', 'FMA:53568', 'FMA:276379', 'FMA:6842', 'FMA:8794', 'FMA:8820', 'FMA:53572', 'FMA:53409', 'FMA:37070', 'FMA:6119', 'FMA:53433', 'FMA:7123', 'FMA:8811', 'FMA:65444', 'FMA:52806', 'FMA:53245', 'FMA:65285', 'FMA:6768', 'FMA:8731', 'FMA:11220', 'FMA:6778', 'FMA:53509', 'FMA:55158', 'FMA:53567', 'FMA:65994', 'FMA:53539', 'FMA:45327', 'FMA:8865', 'FMA:44898', 'FMA:52673', 'FMA:80026', 'FMA:52980', 'FMA:53505', 'FMA:82952', 'FMA:21872', 'FMA:37065', 'FMA:52988', 'FMA:8815', 'FMA:53398', 'FMA:52729', 'FMA:81289', 'FMA:65398', 'FMA:52977', 'FMA:8887'],
    "subclass labels": ['Left T9 white ramus communicans', 'Right T10 grey ramus communicans', 'Right T4 spinal nerve posterior ramus', 'Right fourth intercostal nerve', 'Right anterior interosseous nerve', 'Right perineal nerve', 'Left lateral calcaneal branch A of left sural nerve', 'Right C3 spinal nerve posterior ramus medial branch', 'Oesophageal branch of left recurrent laryngeal nerve', 'Anterior branch of lateral cutaneous branch of left third intercostal nerve', 'Left common plantar digital nerve F', 'Anterior cutaneous branch of right subcostal nerve', 'Left superior labial branch of infraorbital nerve', 'Left T1 spinal nerve posterior ramus', 'Anterior branch of left obturator nerve', 'Right T2 grey ramus communicans', 'Right T9 grey ramus communicans', 'Left T5 white ramus communicans', 'Left L3 spinal nerve posterior ramus lateral branch', 'Communicating branch of left vagus nerve with left glossopharyngeal nerve', 'Right second intercostal nerve', 'Right proper palmar digital nerve G', 'Left musculocutaneous nerve', 'Anterior cutaneous branch of left ninth intercostal nerve', 'Posterior branch of lateral cutaneous branch of left sixth intercostal nerve', 'Right proper palmar digital nerve H', 'Communicating branch of right vagus nerve with right glossopharyngeal nerve', 'Anterior branch of lateral cutaneous branch of right ninth intercostal nerve', 'Right proper plantar digital nerve C', 'Left genital branch of genitofemoral nerve', 'Left T6 grey ramus communicans', 'Right proper palmar digital nerve I', 'Right T12 spinal nerve posterior ramus', 'Right ilioinguinal nerve', 'Right T8 spinal nerve posterior ramus', 'Left T9 spinal nerve posterior ramus', 'Right T11 spinal nerve posterior ramus lateral branch', 'Right proper plantar digital nerve J', 'Right medial sural cutaneous nerve', 'Right T6 spinal nerve posterior ramus medial branch', 'Right lesser occipital nerve', 'Right phrenic nerve', 'Right proper palmar digital nerve E', 'Left median nerve', 'Right S3 grey ramus communicans', 'Right T4 white ramus communicans', 'Right medial cutaneous nerve of forearm', 'Right posterior femoral cutaneous nerve', 'Right vestibular nerve', 'Lateral cutaneous branch of left sixth intercostal nerve', 'Left supratrochlear nerve', 'Right median nerve', 'Anterior branch of right medial cutaneous nerve of forearm', 'Right T5 spinal nerve posterior ramus medial branch', 'Anterior cutaneous branch of right third intercostal nerve', 'Right C6 spinal nerve posterior ramus', 'Temporal branch of left facial nerve', 'Anterior cutaneous branch of left eighth intercostal nerve', 'Right buccal nerve', 'Right middle superior alveolar nerve', 'Temporal branch of right facial nerve', 'Left superficial branch of radial nerve', 'Left medial sural cutaneous nerve', 'Left C4 spinal nerve posterior ramus', 'Left lateral dorsal digital nerve of the third toe', 'Right T12 spinal nerve posterior ramus lateral branch', 'Anterior branch of lateral cutaneous branch of left eleventh intercostal nerve', 'Left T12 spinal nerve posterior ramus', 'Left anterior supraclavicular nerve', 'Left lesser occipital nerve', 'Right deep fibular nerve', 'Left T11 spinal nerve posterior ramus', 'Posterior branch of lateral cutaneous branch of left tenth intercostal nerve', 'Right anterior superior alveolar nerve', 'Left tenth intercostal nerve', 'Anterior branch of lateral cutaneous branch of right fourth intercostal nerve', 'Communicating branch of left glossopharyngeal nerve with auricular branch of left vagus nerve', 'Left iliohypogastric nerve', 'Cervical branch of left facial nerve', 'Right proper palmar digital nerve J', 'Lateral cutaneous branch of right sixth intercostal nerve', 'Right T8 white ramus communicans', 'Left maxillary nerve', 'Left intercostobrachial nerve', 'Left tentorial nerve', 'Right zygomaticotemporal nerve', 'Communicating branch of right internal laryngeal nerve with right recurrent laryngeal nerve', 'Left fourth intercostal nerve', 'Brachial plexus left C7 root', 'Vagal branch to right carotid body', 'Right proper plantar digital nerve G', 'Right tympanic nerve', 'Left lateral plantar nerve', 'Lateral cutaneous branch of left tenth intercostal nerve', 'Right tibial nerve', 'Left third occipital nerve', 'Anterior branch of lateral cutaneous branch of left tenth intercostal nerve', 'Right T8 spinal nerve posterior ramus lateral branch', 'Right S1 grey ramus communicans', 'Left L3 spinal nerve posterior ramus', 'Palmar cutaneous branch of left ulnar nerve', 'Right greater petrosal nerve', 'Left subcostal nerve', 'Anterior branch of left medial cutaneous nerve of forearm', 'Left proper plantar digital nerve C', 'Left C3 spinal nerve branch to left supraclavicular nerve', 'Right posterior cutaneous nerve of forearm', 'Posterior branch of lateral cutaneous branch of right tenth intercostal nerve', 'Right sciatic nerve', 'Left L5 grey ramus communicans', 'Right C4 spinal nerve posterior ramus medial branch', 'Right L4 grey ramus communicans', 'Left T11 white ramus communicans', 'Posterior branch of lateral cutaneous branch of right eighth intercostal nerve', 'Left L1 grey ramus communicans', 'Posterior branch of left medial cutaneous nerve of forearm', 'Left auriculotemporal nerve', 'Left L2 white ramus communicans', 'Marginal mandibular branch of right facial nerve', 'Right T8 grey ramus communicans', 'Right C4 spinal nerve posterior ramus', 'Right fifth intercostal nerve', 'Left common fibular nerve', 'Left posterior ethmoidal nerve', 'Pharyngeal branch of right glossopharyngeal nerve', 'Anterior branch of lateral cutaneous branch of right third intercostal nerve', 'Communicating branch of right external laryngeal nerve with right superior cardiac nerve', 'Right posterior supraclavicular nerve', 'Left medial dorsal cutaneous nerve', 'Lateral cutaneous branch of right eleventh intercostal nerve', 'Posterior branch of lateral cutaneous branch of left subcostal nerve', 'Anterior cutaneous branch of left second intercostal nerve', 'Left lingual nerve', 'Right lateral calcaneal branch A of right sural nerve', 'Left phrenic nerve', 'Right hypogastric nerve', 'Medial calcaneal branch A of left tibial nerve', 'Left perineal nerve', 'Right posterior scrotal nerve', 'Right inferior alveolar nerve', 'Medial calcaneal branch A of right tibial nerve', 'Right T7 white ramus communicans', 'Left frontal nerve', 'Right T1 spinal nerve posterior ramus medial branch', 'Right genitofemoral nerve', 'Zygomatic branch of right facial nerve', 'Lateral cutaneous branch of left ninth intercostal nerve', 'Left C2 spinal nerve branch to left great auricular nerve', 'Right anterior supraclavicular nerve', 'Lateral cutaneous branch of right fourth intercostal nerve', 'Left T11 grey ramus communicans', 'Lingual branch of right vagus nerve', 'Left T1 white ramus communicans', 'Left C3 spinal nerve posterior ramus medial branch', 'Left proper plantar digital nerve J', 'Left T2 grey ramus communicans', 'Brachial plexus left C6 root', 'Left T10 spinal nerve posterior ramus', 'Right genital branch of genitofemoral nerve', 'Anterior cutaneous branch of right first intercostal nerve', 'Left middle meningeal nerve', 'Anterior cutaneous branch of left eleventh intercostal nerve', 'Left infratrochlear nerve', 'Vagal branch to left carotid body', 'Anterior cutaneous branch of right eleventh intercostal nerve', 'Right proper palmar digital nerve B', 'Left proper palmar digital nerve H', 'Anterior branch of lateral cutaneous branch of left fourth intercostal nerve', 'Left seventh intercostal nerve', 'Right nasociliary nerve', 'Left posterior scrotal nerve', 'Left sural nerve', 'Right S5 grey ramus communicans', 'Brachial plexus right C7 root', 'Right inferior rectal nerve', 'Right transverse cervical nerve', 'Anterior cutaneous branch of left third intercostal nerve', 'Left proper plantar digital nerve H', 'Superficial branch of left ulnar nerve', 'Dorsal branch of left ulnar nerve', 'Right eleventh intercostal nerve', 'Right T2 white ramus communicans', 'Right common plantar digital nerve F', 'Infrapatellar branch of right saphenous nerve', 'Left T5 grey ramus communicans', 'Lingual branch of left vagus nerve', 'Thoracic cardiac branch of left vagus nerve', 'Right superior laryngeal nerve', 'Right C2 spinal nerve posterior ramus', 'Right zygomatic nerve', 'Right auriculotemporal nerve', 'Anterior branch of lateral cutaneous branch of left subcostal nerve', 'Left saphenous nerve', 'Right L3 spinal nerve posterior ramus', 'Right T7 grey ramus communicans', 'Left great auricular nerve posterior branch', 'Left proper palmar digital nerve A', 'Right infraorbital nerve', 'Cutaneous branch of right obturator nerve', 'Posterior branch of right obturator nerve', 'Left T1 grey ramus communicans', 'Right T12 white ramus communicans', 'Right proper plantar digital nerve F', 'Left posterior auricular nerve', 'Right posterior ethmoidal nerve', 'Buccal branch of right facial nerve', 'Right iliohypogastric nerve', 'Left dorsal nerve of penis', 'Right inferior lateral cutaneous nerve of arm', 'Left T7 spinal nerve posterior ramus lateral branch', 'Lateral cutaneous branch of left seventh intercostal nerve', 'Right posterior interosseous nerve', 'Left middle superior alveolar nerve', 'Right T9 white ramus communicans', 'Right T10 spinal nerve posterior ramus', 'Left deep fibular nerve', 'Hepatic branch of anterior vagal trunk', 'Left first intercostal nerve', 'Right L2 white ramus communicans', 'Buccal branch of left facial nerve', 'Right L5 grey ramus communicans', 'Right common fibular nerve', 'Left T6 spinal nerve posterior ramus medial branch', 'Right L2 grey ramus communicans', 'Right deep petrosal nerve', 'Left axillary nerve posterior branch', 'Right posterior auricular nerve', 'Anterior branch of lateral cutaneous branch of right subcostal nerve', 'Anterior branch of lateral cutaneous branch of right fifth intercostal nerve', 'Pyloric branch of greater posterior gastric nerve', 'Left T10 spinal nerve posterior ramus lateral branch', 'Superior cervical cardiac branch of right vagus nerve', 'Ganglionic branch of right maxillary nerve to pterygopalatine ganglion', 'Left proper palmar digital nerve C', 'Right superior cervical cardiac nerve', 'Right ninth intercostal nerve', 'Right lesser petrosal nerve', 'Communicating branch of left external laryngeal nerve with left superior cardiac nerve', 'Right long ciliary nerve B', 'Anterior cutaneous branch of right fourth intercostal nerve', 'Right third intercostal nerve', 'Left L4 grey ramus communicans', 'Right T7 spinal nerve posterior ramus', 'Left L2 spinal nerve posterior ramus lateral branch', 'Left proper palmar digital nerve F', 'Coeliac branch of posterior vagal trunk', 'Left lacrimal nerve', 'Right lacrimal nerve', 'Anterior cutaneous branch of right seventh intercostal nerve', 'Left femoral nerve', 'Right maxillary nerve', 'Lateral cutaneous branch of right third intercostal nerve', 'Right superficial fibular nerve', 'Left proper palmar digital nerve I', 'Anterior cutaneous branch of left seventh intercostal nerve', 'Left T12 spinal nerve posterior ramus lateral branch', 'Thoracic cardiac branch of right vagus nerve', 'Lateral cutaneous branch of left eighth intercostal nerve', 'Orbital branch of left maxillary nerve to left ethmoidal sinus', 'Left pudendal nerve', 'Left lesser petrosal nerve', 'Right eighth intercostal nerve', 'Left S5 grey ramus communicans', 'Right T10 white ramus communicans', 'Left T10 white ramus communicans', 'Left T4 white ramus communicans', 'Lateral cutaneous branch of left third intercostal nerve', 'Posterior branch of lateral cutaneous branch of left eighth intercostal nerve', 'Lateral cutaneous branch of right iliohypogastric nerve', 'Right supratrochlear nerve', 'Anterior branch of lateral cutaneous branch of right tenth intercostal nerve', 'Right C3 spinal nerve branch to right supraclavicular nerve', 'Right T6 grey ramus communicans', 'Left T5 spinal nerve posterior ramus medial branch', 'Left proper palmar digital nerve G', 'Left posterior superior alveolar nerve', 'Lateral cutaneous branch of left subcostal nerve', 'Gluteal branch A of right posterior femoral cutaneous nerve', 'Right T5 white ramus communicans', 'Left greater petrosal nerve', 'Left T3 spinal nerve posterior ramus', 'Right subcostal nerve', 'Right femoral branch of genitofemoral nerve', 'Right sixth intercostal nerve', 'Anterior cutaneous branch of right ninth intercostal nerve', 'Left T11 spinal nerve posterior ramus lateral branch', 'Left T7 grey ramus communicans', 'Posterior branch of lateral cutaneous branch of right subcostal nerve', 'Left L2 grey ramus communicans', 'Posterior branch of lateral cutaneous branch of right third intercostal nerve', 'Right L1 white ramus communicans', 'Anterior branch of right obturator nerve', 'Anterior cutaneous branch of left fifth intercostal nerve', 'Left T4 grey ramus communicans', 'Right C5 spinal nerve posterior ramus medial branch', 'Right T4 spinal nerve posterior ramus medial branch', 'Left L1 white ramus communicans', 'Anterior cutaneous branch of right eighth intercostal nerve', 'Left subclavian nerve', 'Pericardial branch of left phrenic nerve', 'Left tympanic nerve', 'Right zygomaticofacial nerve', 'Right intercostobrachial nerve', 'Right cochlear nerve', 'Left internal laryngeal nerve', 'Right lateral dorsal digital nerve of the third toe', 'Left proper palmar digital nerve D', 'Inferior cervical cardiac branch of left vagus nerve', 'Left proper plantar digital nerve B', 'Right S2 grey ramus communicans', 'Right proper plantar digital nerve H', 'Right tentorial nerve', 'Right T1 white ramus communicans', 'Inferior ramus of left internal laryngeal nerve', 'Right L3 grey ramus communicans', 'Right posterior superior alveolar nerve', 'Tonsillar branch of right glossopharyngeal nerve', 'Lateral cutaneous branch of right subcostal nerve', 'Right proper palmar digital nerve C', 'Right first intercostal nerve', 'Posterior branch of right medial cutaneous nerve of forearm', 'Right lingual nerve', 'Lateral cutaneous branch of right fifth intercostal nerve', 'Left T4 spinal nerve posterior ramus', 'Posterior branch of lateral cutaneous branch of left third intercostal nerve', 'Right posterior superior lateral nasal branch of maxillary nerve', 'Posterior branch of lateral cutaneous branch of right fifth intercostal nerve', 'Left buccal nerve', 'Right third occipital nerve', 'Left anterior ethmoidal nerve', 'Right lingual branch of glossopharyngeal nerve', 'Left laryngopharyngeal branch of superior cervical ganglion', 'Right infratrochlear nerve', 'Left external laryngeal nerve branch to pharyngeal plexus', 'Left T7 white ramus communicans', 'Left L1 spinal nerve posterior ramus', 'Right S4 grey ramus communicans', 'Left proper palmar digital nerve J', 'Left zygomatic nerve', 'Left L1 spinal nerve posterior ramus lateral branch', 'Left greater occipital nerve', 'Left medial cutaneous nerve of forearm', 'Brachial plexus left C8 root', 'Left anterior femoral cutaneous branch A', 'Posterior branch of lateral cutaneous branch of left seventh intercostal nerve', 'Left T1 spinal nerve posterior ramus medial branch', 'Left meningeal branch of mandibular nerve', 'Left medial dorsal digital nerve of the fourth toe', 'Left C5 spinal nerve posterior ramus', 'Pharyngeal branch of left glossopharyngeal nerve', 'Right medial plantar nerve', 'Left proper plantar digital nerve F', 'Left deep petrosal nerve', 'Right supraorbital nerve', 'Left proper plantar digital nerve E', 'Right T9 spinal nerve posterior ramus lateral branch', 'Left posterior cutaneous nerve of forearm', 'Left posterior femoral cutaneous nerve', 'Left hypogastric nerve', 'Left genitofemoral nerve', 'Anterior branch of lateral cutaneous branch of left ninth intercostal nerve', 'Right T1 spinal nerve posterior ramus', 'Right common palmar digital nerve A', 'Right L3 spinal nerve posterior ramus lateral branch', 'Left anterior superior alveolar nerve', 'Right T1 grey ramus communicans', 'Anterior cutaneous branch of left sixth intercostal nerve', 'Left proper plantar digital nerve A', 'Left T5 spinal nerve posterior ramus', 'Right T3 spinal nerve posterior ramus', 'Right superior labial branch of infraorbital nerve', 'Left proper palmar digital nerve E', 'Left transverse cervical nerve', 'Posterior branch of lateral cutaneous branch of right fourth intercostal nerve', 'Left communicating branch of nasociliary nerve with ciliary ganglion', 'Superficial branch of right ulnar nerve', 'Right great auricular nerve posterior branch', 'Palmar branch of right median nerve', 'Right ulnar nerve', 'Right T5 grey ramus communicans', 'Palmar cutaneous branch of right ulnar nerve', 'Left T2 spinal nerve posterior ramus medial branch', 'Tonsillar branch of left glossopharyngeal nerve', 'Lateral cutaneous branch of right eighth intercostal nerve', 'Posterior branch of lateral cutaneous branch of right eleventh intercostal nerve', 'Left T6 white ramus communicans', 'Right T4 grey ramus communicans', 'Branch of right vagus nerve to oesophageal nerve plexus', 'Superior cervical cardiac branch of left vagus nerve', 'Left long thoracic nerve', 'Right mental nerve', 'Left fifth intercostal nerve', 'Lateral cutaneous branch of left fourth intercostal nerve', 'Right lateral femoral cutaneous nerve', 'Posterior branch of lateral cutaneous branch of right seventh intercostal nerve', 'Lateral cutaneous branch of right seventh intercostal nerve', 'Left C4 spinal nerve posterior ramus medial branch', 'Right intermediate dorsal cutaneous nerve', 'Right medial dorsal cutaneous nerve', 'Left recurrent laryngeal nerve', 'Left obturator nerve', 'Left T8 grey ramus communicans', 'Right T2 spinal nerve posterior ramus', 'Right T3 spinal nerve posterior ramus medial branch', 'Left T2 spinal nerve posterior ramus', 'Right superficial branch of radial nerve', 'Right C3 spinal nerve branch to right great auricular nerve', 'Left anterior interosseous nerve', 'Lateral cutaneous branch of right ninth intercostal nerve', 'Left common plantar digital nerve E', 'Brachial plexus left C5 root', 'Left external laryngeal nerve', 'Left C3 spinal nerve posterior ramus', 'Oesophageal branch of right recurrent laryngeal nerve', 'Lateral cutaneous branch of right tenth intercostal nerve', 'Anterior cutaneous branch of right sixth intercostal nerve', 'Right T3 white ramus communicans', 'Left T9 grey ramus communicans', 'Auricular branch of right vagus nerve', 'Right lateral sural cutaneous nerve', 'Left ulnar nerve', 'Right long ciliary nerve A', 'Left sciatic nerve', 'Anterior branch of lateral cutaneous branch of left fifth intercostal nerve', 'Right inferior palpebral branch of infraorbital nerve', 'Right medial cutaneous nerve of arm', 'Auricular branch of left vagus nerve', 'Left T10 grey ramus communicans', 'Left medial posterior superior nasal nerve', 'Pharyngeal branch of right vagus nerve to pharyngeal nerve plexus', 'Left L3 grey ramus communicans', 'Left lateral femoral cutaneous nerve', 'Right external laryngeal nerve branch to pharyngeal plexus', 'Left eighth intercostal nerve', 'Right T5 spinal nerve posterior ramus', 'Left tibial nerve', 'Right superior lateral cutaneous nerve of arm', 'Right lateral plantar nerve', 'Anterior cutaneous branch of left first intercostal nerve', 'Brachial plexus right C8 root', 'Lateral cutaneous branch of left iliohypogastric nerve', 'Posterior branch of lateral cutaneous branch of left eleventh intercostal nerve', 'Right long thoracic nerve', 'Left lateral cutaneous nerve of forearm', 'Left posterior supraclavicular nerve', 'Left T3 grey ramus communicans', 'Left ilioinguinal nerve', 'Left mental nerve', 'Left T12 white ramus communicans', 'Left superficial fibular nerve', 'Right proper palmar digital nerve F', 'Right proper palmar digital nerve D', 'Right lateral cutaneous nerve of forearm', 'Gluteal branch A of left posterior femoral cutaneous nerve', 'Lateral cutaneous branch of left fifth intercostal nerve', 'Right L1 spinal nerve posterior ramus lateral branch', 'Right axillary nerve anterior branch', 'Orbital branch of right maxillary nerve to right ethmoidal sinus', 'Right C6 spinal nerve posterior ramus medial branch', 'Posterior branch of lateral cutaneous branch of right ninth intercostal nerve', 'Right recurrent laryngeal nerve', 'Right sural nerve', 'Dorsal branch of right ulnar nerve', 'Right common plantar digital nerve E', 'Right medial dorsal digital nerve of the fourth toe', 'Right proper plantar digital nerve E', 'Left caroticotympanic nerve', 'Greater posterior gastric nerve', 'Right L1 spinal nerve posterior ramus', 'Pericardial branch of right phrenic nerve', 'Anterior branch of lateral cutaneous branch of right eighth intercostal nerve', 'Left incisive branch of inferior alveolar nerve', 'Right T3 grey ramus communicans', 'Left posterior interosseous nerve', 'Palmar branch of left median nerve', 'Left nasociliary nerve', 'Right external laryngeal nerve', 'Pharyngeal branch of left vagus nerve to pharyngeal nerve plexus', 'Right T11 grey ramus communicans', 'Right dorsal nerve of penis', 'Left C6 spinal nerve posterior ramus', 'Left axillary nerve anterior branch', 'Meningeal branch of left vagus nerve', 'Left intermediate dorsal cutaneous nerve', 'Right laryngopharyngeal branch of superior cervical ganglion', 'Right great auricular nerve anterior branch', 'Zygomatic branch of left facial nerve', 'Left C5 spinal nerve posterior ramus medial branch', 'Marginal mandibular branch of left facial nerve', 'Right L1 grey ramus communicans', 'Right meningeal branch of mandibular nerve', 'Right femoral nerve', 'Tracheal branch of right recurrent laryngeal nerve', 'Left posterior cutaneous nerve of arm', 'Left inferior lateral cutaneous nerve of arm', 'Right L2 spinal nerve posterior ramus', 'Right lateral dorsal cutaneous nerve', 'Anterior cutaneous branch of right second intercostal nerve', 'Left nasopalatine nerve', 'Left T3 spinal nerve posterior ramus medial branch', 'Left superior cervical cardiac nerve', 'Posterior branch of lateral cutaneous branch of left ninth intercostal nerve', 'Right T7 spinal nerve posterior ramus lateral branch', 'Right frontal nerve', 'Anterior cutaneous branch of left tenth intercostal nerve', 'Ganglionic branch of left maxillary nerve to pterygopalatine ganglion', 'Left S1 grey ramus communicans', 'Left lesser palatine nerve', 'Left medial plantar nerve', 'Communicating branch of right glossopharyngeal nerve with auricular branch of right vagus nerve', 'Left zygomaticotemporal nerve', 'Anterior cutaneous branch of right fifth intercostal nerve', 'Left proper palmar digital nerve B', 'Left radial nerve', 'Posterior branch of lateral cutaneous branch of left fourth intercostal nerve', 'Left S3 grey ramus communicans', 'Left T3 white ramus communicans', 'Right T11 spinal nerve posterior ramus', 'Left ninth intercostal nerve', 'Right T2 spinal nerve posterior ramus medial branch', 'Anterior cutaneous branch of left subcostal nerve', 'Right proper plantar digital nerve B', 'Left C2 spinal nerve posterior ramus', 'Right axillary nerve', 'Left axillary nerve', 'Left common palmar digital nerve A', 'Left proper plantar digital nerve D', 'Left femoral branch of genitofemoral nerve', 'Left second intercostal nerve', 'Left medial cutaneous nerve of arm', 'Left lateral sural cutaneous nerve', 'Right ophthalmic nerve', 'Right carotid sinus nerve', 'Right T10 spinal nerve posterior ramus lateral branch', 'Right proper plantar digital nerve D', 'Right mandibular nerve', 'Right obturator nerve', 'Left C3 spinal nerve branch to left great auricular nerve', 'Left lateral dorsal cutaneous nerve', 'Right greater palatine nerve', 'Right L2 spinal nerve posterior ramus lateral branch', 'Brachial plexus right C5 root', 'Left posterior superior lateral nasal branch of maxillary nerve', 'Right proper plantar digital nerve I', 'Right seventh intercostal nerve', 'Anterior branch of lateral cutaneous branch of right eleventh intercostal nerve', 'Right tenth intercostal nerve', 'Left mandibular nerve', 'Left greater palatine nerve', 'Left T12 grey ramus communicans', 'Inferior cervical cardiac branch of right vagus nerve', 'Left ophthalmic nerve', 'Left superior laryngeal nerve', 'Right T12 grey ramus communicans', 'Cutaneous branch of left obturator nerve', 'Left long ciliary nerve B', 'Left S4 grey ramus communicans', 'Left T4 spinal nerve posterior ramus medial branch', 'Greater anterior gastric nerve', 'Orbital branch of left maxillary nerve to left sphenoidal sinus', 'Orbital branch of right maxillary nerve to right sphenoidal sinus', 'Right middle supraclavicular nerve', 'Right caroticotympanic nerve', 'Left sixth intercostal nerve', 'Right posterior cutaneous nerve of arm', 'Left middle supraclavicular nerve', 'Left proper plantar digital nerve I', 'Anterior branch of lateral cutaneous branch of right sixth intercostal nerve', 'Left L2 spinal nerve posterior ramus', 'Anterior branch of lateral cutaneous branch of left seventh intercostal nerve', 'Posterior branch of lateral cutaneous branch of right sixth intercostal nerve', 'Left T8 spinal nerve posterior ramus lateral branch', 'Meningeal branch of right vagus nerve', 'Tracheal branch of left recurrent laryngeal nerve', 'Anterior cutaneous branch of right tenth intercostal nerve', 'Left eleventh intercostal nerve', 'Right pudendal nerve', 'Posterior branch of lateral cutaneous branch of left fifth intercostal nerve', 'Right anterior ethmoidal nerve', 'Right nasopalatine nerve', 'Left T8 spinal nerve posterior ramus', 'Left long ciliary nerve A', 'Left supraorbital nerve', 'Right medial posterior superior nasal nerve', 'Left T8 white ramus communicans', 'Right anterior femoral cutaneous branch A', 'Left T2 white ramus communicans', 'Right saphenous nerve', 'Anterior branch of lateral cutaneous branch of right seventh intercostal nerve', 'Left superior lateral cutaneous nerve of arm', 'Left T9 spinal nerve posterior ramus lateral branch', 'Left T6 spinal nerve posterior ramus', 'Posterior branch of left obturator nerve', 'Left external laryngeal nerve branch to inferior pharyngeal constrictor', 'Right incisive branch of inferior alveolar nerve', 'Right C3 spinal nerve posterior ramus', 'Right C5 spinal nerve posterior ramus', 'Right T9 spinal nerve posterior ramus', 'Communicating branch of left internal laryngeal nerve with left recurrent laryngeal nerve', 'Left vestibular nerve', 'Right radial nerve', 'Left third intercostal nerve', 'Left cochlear nerve', 'Anterior cutaneous branch of left fourth intercostal nerve', 'Right T6 spinal nerve posterior ramus', 'Right greater occipital nerve', 'Right lesser palatine nerve', 'Left inferior alveolar nerve', 'Right subclavian nerve', 'Right T6 white ramus communicans', 'Brachial plexus right C6 root', 'Lateral cutaneous branch of left eleventh intercostal nerve', 'Right T11 white ramus communicans', 'Left carotid sinus nerve', 'Left great auricular nerve anterior branch', 'Right external laryngeal nerve branch to inferior pharyngeal constrictor', 'Left S2 grey ramus communicans', 'Right internal laryngeal nerve', 'Infrapatellar branch of left saphenous nerve', 'Anterior branch of lateral cutaneous branch of left sixth intercostal nerve', 'Right proper palmar digital nerve A', 'Right communicating branch of nasociliary nerve with ciliary ganglion', 'Left proper plantar digital nerve G', 'Left infraorbital nerve', 'Left lingual branch of glossopharyngeal nerve', 'Right proper plantar digital nerve A', 'Left inferior rectal nerve', 'Right musculocutaneous nerve', 'Left inferior palpebral branch of infraorbital nerve', 'Left T7 spinal nerve posterior ramus', 'Cervical branch of right facial nerve', 'Right middle meningeal nerve', 'Right axillary nerve posterior branch', 'Right C2 spinal nerve branch to right great auricular nerve', 'Left zygomaticofacial nerve', 'Anterior branch of lateral cutaneous branch of left eighth intercostal nerve']
  },
  {
    "id": 77,
    "nerve_id": "UBERON:0001647",
    "label": "facial nerve",
    "FMA subclasses (in human nerves)": ['FMA:50888', 'FMA:50889'],
    "subclass labels": ['Right facial nerve', 'Left facial nerve']
  },
  {
    "id": 78,
    "nerve_id": "UBERON:0001148",
    "label": "median nerve",
    "FMA subclasses (in human nerves)": ['FMA:37067', 'FMA:37068'],
    "subclass labels": ['Right median nerve', 'Left median nerve']
  },
  {
    "id": 79,
    "nerve_id": "UBERON:0009009",
    "label": "carotid sinus nerve",
    "FMA subclasses (in human nerves)": ['FMA:53508', 'FMA:53509'],
    "subclass labels": ['Right carotid sinus nerve', 'Left carotid sinus nerve']
  },
  {
    "id": 80,
    "nerve_id": "UBERON:0003715",
    "label": "splanchnic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6924', 'FMA:6928', 'FMA:6929', 'FMA:6931', 'FMA:6930', 'FMA:6960', 'FMA:6958', 'FMA:6959', 'FMA:6925', 'FMA:6956', 'FMA:6927', 'FMA:6955', 'FMA:6926', 'FMA:6957'],
    "subclass labels": ['Right first lumbar splanchnic nerve', 'Right third lumbar splanchnic nerve', 'Left third lumbar splanchnic nerve', 'Left fourth lumbar splanchnic nerve', 'Right fourth lumbar splanchnic nerve', 'Left least splanchnic nerve', 'Left lesser splanchnic nerve', 'Right least splanchnic nerve', 'Left first lumbar splanchnic nerve', 'Right greater splanchnic nerve', 'Left second lumbar splanchnic nerve', 'Left greater splanchnic nerve', 'Right second lumbar splanchnic nerve', 'Right lesser splanchnic nerve']
  },
  {
    "id": 81,
    "nerve_id": "ILX:0793826",
    "label": "anterior abdominal vagal trunk",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 82,
    "nerve_id": "UBERON:0001650",
    "label": "hypoglossal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 83,
    "nerve_id": "ILX:0794967",
    "label": "posterior interosseous nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 84,
    "nerve_id": "ILX:0793713",
    "label": "Deep petrosal nerve",
    "FMA subclasses (in human nerves)": ['FMA:0328827', 'FMA:0328826'],
    "subclass labels": ['Left deep petrosal nerve', 'Right deep petrosal nerve']
  },
  {
    "id": 85,
    "nerve_id": "ILX:0793361",
    "label": "white communicating ramus of third lumbar spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 86,
    "nerve_id": "ILX:0787562",
    "label": "gray communicating ramus of the third thoracic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6133', 'FMA:6124'],
    "subclass labels": ['Left T3 grey ramus communicans', 'Right T3 grey ramus communicans']
  },
  {
    "id": 87,
    "nerve_id": "ILX:0793211",
    "label": "white communicating ramus of fifth thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 88,
    "nerve_id": "UBERON:0018679",
    "label": "thoracic splanchnic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6958', 'FMA:6960', 'FMA:6955', 'FMA:6959', 'FMA:6957', 'FMA:6956'],
    "subclass labels": ['Left lesser splanchnic nerve', 'Left least splanchnic nerve', 'Left greater splanchnic nerve', 'Right least splanchnic nerve', 'Right lesser splanchnic nerve', 'Right greater splanchnic nerve']
  },
  {
    "id": 89,
    "nerve_id": "ILX:0731969",
    "label": "least splanchnic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6960', 'FMA:6959'],
    "subclass labels": ['Left least splanchnic nerve', 'Right least splanchnic nerve']
  },
  {
    "id": 90,
    "nerve_id": "ILX:0788771",
    "label": "gray communicating ramus of seventh thoracic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6888', 'FMA:6889'],
    "subclass labels": ['Right T7 grey ramus communicans', 'Left T7 grey ramus communicans']
  },
  {
    "id": 91,
    "nerve_id": "UBERON:0022301",
    "label": "long ciliary nerve",
    "FMA subclasses (in human nerves)": ['FMA:52701', 'FMA:52700', 'FMA:82734', 'FMA:82735'],
    "subclass labels": ['Left long ciliary nerve B', 'Right long ciliary nerve B', 'Right long ciliary nerve A', 'Left long ciliary nerve A']
  },
  {
    "id": 92,
    "nerve_id": "ILX:0793221",
    "label": "white communicating ramus of second lumbar spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 93,
    "nerve_id": "ILX:0785825",
    "label": "gray communicating ramus of first lumbar nerve",
    "FMA subclasses (in human nerves)": ['FMA:65924', 'FMA:65923'],
    "subclass labels": ['Left L1 grey ramus communicans', 'Right L1 grey ramus communicans']
  },
  {
    "id": 94,
    "nerve_id": "ILX:0793208",
    "label": "white communicating ramus of second thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 95,
    "nerve_id": "UBERON:0018412",
    "label": "vidian nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 96,
    "nerve_id": "ILX:0739303",
    "label": "gray communicating ramus of second thoracic nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 97,
    "nerve_id": "ILX:0795006",
    "label": "Suboccipital nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 98,
    "nerve_id": "ILX:0785733",
    "label": "gray communicating ramus of second lumbar nerve",
    "FMA subclasses (in human nerves)": ['FMA:65921', 'FMA:65922'],
    "subclass labels": ['Right L2 grey ramus communicans', 'Left L2 grey ramus communicans']
  },
  {
    "id": 99,
    "nerve_id": "UBERON:0035207",
    "label": "deep fibular nerve",
    "FMA subclasses (in human nerves)": ['FMA:45387', 'FMA:45388'],
    "subclass labels": ['Right deep fibular nerve', 'Left deep fibular nerve']
  },
  {
    "id": 100,
    "nerve_id": "ILX:0739304",
    "label": "gray communicating ramus of third thoracic nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 101,
    "nerve_id": "UBERON:0002019",
    "label": "accessory XI nerve",
    "FMA subclasses (in human nerves)": ['FMA:50899', 'FMA:50897'],
    "subclass labels": ['Left accessory nerve', 'Right accessory nerve']
  },
  {
    "id": 102,
    "nerve_id": "ILX:0793217",
    "label": "white communicating ramus of eleventh thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 103,
    "nerve_id": "ILX:0793722",
    "label": "Lesser petrosal nerve",
    "FMA subclasses (in human nerves)": ['FMA:53503', 'FMA:53502'],
    "subclass labels": ['Left lesser petrosal nerve', 'Right lesser petrosal nerve']
  },
  {
    "id": 104,
    "nerve_id": "UBERON:0018675",
    "label": "pelvic splanchnic nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 105,
    "nerve_id": "ILX:0793702",
    "label": "Greater petrosal nerve",
    "FMA subclasses (in human nerves)": ['FMA:53423', 'FMA:53424'],
    "subclass labels": ['Right greater petrosal nerve', 'Left greater petrosal nerve']
  },
  {
    "id": 106,
    "nerve_id": "ILX:0794916",
    "label": "white ramus communicans",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 107,
    "nerve_id": "UBERON:0003716",
    "label": "Recurrent Laryngeal Nerve",
    "FMA subclasses (in human nerves)": ['UBERON:0011766', 'UBERON:0011767'],
    "subclass labels": ['Left recurrent laryngeal nerve', 'Right recurrent laryngeal nerve']
  },
  {
    "id": 108,
    "nerve_id": "UBERON:0005465",
    "label": "obturator nerve",
    "FMA subclasses (in human nerves)": ['FMA:16501', 'FMA:16502'],
    "subclass labels": ['Right obturator nerve', 'Left obturator nerve']
  },
  {
    "id": 109,
    "nerve_id": "ILX:0793213",
    "label": "white communicating ramus of seventh thoracic spinal nerve",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 110,
    "nerve_id": "ILX:0785067",
    "label": "gray communicating ramus of eleventh thoracic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6897', 'FMA:6896'],
    "subclass labels": ['Left T11 grey ramus communicans', 'Right T11 grey ramus communicans']
  },
  {
    "id": 111,
    "nerve_id": "UBERON:0001494",
    "label": "ulnar nerve",
    "FMA subclasses (in human nerves)": ['FMA:37320', 'FMA:37321'],
    "subclass labels": ['Right ulnar nerve', 'Left ulnar nerve']
  },
  {
    "id": 112,
    "nerve_id": "ILX:0794959",
    "label": "posterior rami lower cervical nerves",
    "FMA subclasses (in human nerves)": [],
    "subclass labels": []
  },
  {
    "id": 113,
    "nerve_id": "UBERON:0001493",
    "label": "axillary nerve",
    "FMA subclasses (in human nerves)": ['FMA:37074', 'FMA:37073'],
    "subclass labels": ['Left axillary nerve', 'Right axillary nerve']
  },
  {
    "id": 114,
    "nerve_id": "ILX:0787946",
    "label": "gray communicating ramus of sixth thoracic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6762', 'FMA:6763'],
    "subclass labels": ['Right T6 grey ramus communicans', 'Left T6 grey ramus communicans']
  },
  {
    "id": 115,
    "nerve_id": "ILX:0785542",
    "label": "gray communicating ramus of ninth thoracic nerve",
    "FMA subclasses (in human nerves)": ['FMA:6892', 'FMA:6893'],
    "subclass labels": ['Right T9 grey ramus communicans', 'Left T9 grey ramus communicans']
  }
]

const getNerveMaps = () => {
  const curatedMap = {};
  mappedNerves.forEach((item) => {
    if (item["nerve_id"] && item['label'] !== "nerve") {
      item["subclass labels"].forEach((label) => {
        if (!(label in curatedMap)) curatedMap[label.toLowerCase()] = item["nerve_id"];
      });
    }
  });
  return curatedMap;
}

const getTermNerveMaps = () => {
  const curatedMap = {};
  mappedNerves.forEach((item) => {
    const nerve_id = item["nerve_id"];
    const label = item["label"].toLowerCase();
    const subclassLabels = item["subclass labels"];
    if (nerve_id && label !== "nerve") {
      if (!subclassLabels.length) {
        return;
      }
      if (!(nerve_id in curatedMap)) {
        curatedMap[nerve_id] = {};
      }
      const subLabels = subclassLabels
        .map((label) => label.toLowerCase())
        .sort();
      curatedMap[nerve_id] = {
        nerve: label,
        subNerves: subLabels,
      };
    }
  });
  return curatedMap;
};

const getFilterOptions = () => {
  let filterOptions = [];
  let main = {
    key: "scaffold.connectivity.nerve",
    label: "Nerves",
    children: [],
  };
  let children1 = [];
  for (const nerve of mappedNerves) {
    if (nerve.label === "nerve") {
      continue;
    }
    let sub = {
      facetPropPath: "scaffold.connectivity.nerve",
      label: "",
      children: [],
    };
    let children2 = [];
    for (const [key, value] of Object.entries(nerve)) {
      if (key === "label") {
        sub.label = value;
      }
      if (key === "subclass labels") {
        for (const subnerve of value) {
          children2.push({
            facetPropPath: "scaffold.connectivity.subnerve",
            label: subnerve,
          });
        }
      }
    }
    if (children2.length) {
      sub.children = children2.sort((a, b) => a.label.localeCompare(b.label));
      children1.push(sub);
    }
  }
  if (children1.length) {
    main.children = children1.sort((a, b) => a.label.localeCompare(b.label));
    filterOptions.push(main);
  }
  return filterOptions;
};

export {
  getNerveMaps,
  getTermNerveMaps,
  getFilterOptions
};
